<template>
  <v-tooltip v-if="safeValue.name" bottom>
    <span slot="activator">
      <span class="data-table__row__status" :class="valueClasses[safeValue.name] + '--text'">
        {{ safeValue.name }}
      </span>
    </span>
    <span>{{ safeValue.description }}</span>
  </v-tooltip>

  <span v-else class="data-table__row__status" :class="valueClasses[safeValue] + '--text'">
    {{ safeValue }}
  </span>
</template>

<script>
export default {
  props: {
    value: { required: true },
    valueClasses: { type: Object, required: true },
  },
  computed: {
    safeValue() {
      return this.value ? this.value : '';
    },
  },
};
</script>

<style>
  .data-table__row__status {
    font-size: 14px !important;
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayStatus.vue